module.exports = ".post-img {\r\n    max-width: 100px;\r\n}"